import { forwardRef } from "react";
import { Field, Checkbox as GardenCheckbox } from "@zendeskgarden/react-forms";
import type { FormCheckboxProps } from "./Interfaces";
import { useCheckbox } from "./useCheckbox";

export const Checkbox = forwardRef<HTMLInputElement, FormCheckboxProps>(
  (
    {
      id,
      name,
      label,
      hint,
      message,
      validation,
      error,
      className,
      wrapperClassName,
      onCheckedChange,
      onChange,
      onBlur,
      checked,
      defaultChecked,
      ...rest
    },
    ref
  ) => {
    const { checkboxId, finalMessage, finalValidation, handleChange } = useCheckbox({
      onCheckedChange,
      onChange,
      error,
      message,
      validation,
      id,
    });

    return (
      <Field className={wrapperClassName}>
        <GardenCheckbox
          id={checkboxId}
          name={name}
          ref={ref}
          className={className}
          onChange={handleChange}
          onBlur={onBlur}
          checked={checked}
          defaultChecked={defaultChecked}
          {...rest}
        >
          {label && <Field.Label>{label}</Field.Label>}
        </GardenCheckbox>

        {hint && <Field.Hint>{hint}</Field.Hint>}

        {finalMessage && <Field.Message validation={finalValidation}>{finalMessage}</Field.Message>}
      </Field>
    );
  }
);

Checkbox.displayName = "Checkbox";
export default Checkbox;
